export const INTERNATIONAL_ROUTE_FOR_FILTER = {
  origin: 'INT',
  destination: 'INT',
  country: 'INT',
  display_name: 'INT',
  enabled: true,
  local: false,
  defined: true,
  name: 'INT',
  isInternational: true,
  simple_name: 'INT',
  symmetric_name: 'INT',
  enabled_corridor: false,
};

export const INTERNATIONAL_ROUTE_VALUE = INTERNATIONAL_ROUTE_FOR_FILTER.simple_name;

export const isInternationalRoute = (value) => value === INTERNATIONAL_ROUTE_VALUE;

export const hasInternationalRouteSelected = (routes = []) =>
  (routes || []).some(({ value }) => isInternationalRoute(value));

export const sanitizeInternationalSelection = (routes = [], actionMeta = {}) => {
  if (!Array.isArray(routes)) return routes;

  const { action, option } = actionMeta;

  if (action === 'clear') return [];

  if (action === 'remove-value') return routes;

  if (action === 'select-option' && option) {
    const isIntlOption = isInternationalRoute(option.value);
    if (isIntlOption) {
      // Selecting INT clears any other route
      return routes.filter(({ value }) => isInternationalRoute(value));
    }

    // Selecting any other route removes INT
    return routes.filter(({ value }) => !isInternationalRoute(value));
  }

  const hasInternational = hasInternationalRouteSelected(routes);
  const hasOther = (routes || []).some(({ value }) => !isInternationalRoute(value));

  if (hasInternational && hasOther) {
    return routes.filter(({ value }) => !isInternationalRoute(value));
  }

  return routes;
};
